import React from "react";
import { Award, RotateCcw } from "lucide-react";
import { getPublicComponentCopy } from "@/lib/publicComponentCopy";

export default function MiniTopicQuiz({ lang = "en" }) {
  const [answers, setAnswers] = React.useState({});
  const copy = getPublicComponentCopy(lang).learning.quiz;
  const questions = copy.questions.map(([q, options]) => ({ q, options, answer: 0 }));
  const score = questions.reduce((sum, item, index) => sum + (answers[index] === item.answer ? 1 : 0), 0);
  const complete = Object.keys(answers).length === questions.length;

  return (
    <div className="mt-6 rounded-[1.5rem] border border-[#BFDADC] bg-white/92 p-5 shadow-[0_12px_28px_rgba(8,22,51,0.07)]">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div><p className="text-sm font-black uppercase tracking-[0.2em] text-[#168F92]">{copy.eyebrow}</p><h3 className="mt-2 text-2xl font-black text-[#081633]">{copy.title}</h3></div>
        {complete && <div className="rounded-full bg-[#17A6A4]/10 px-4 py-2 text-sm font-black text-[#168F92]"><Award className="mr-1 inline h-4 w-4" />{copy.score} {score}/{questions.length}</div>}
      </div>
      <div className="mt-5 grid gap-4 md:grid-cols-3">
        {questions.map((item, index) => (
          <div key={item.q} className="rounded-2xl border border-[#BFDADC] bg-[#F5FFFF] p-4">
            <p className="font-black text-[#081633]">{index + 1}. {item.q}</p>
            <div className="mt-3 space-y-2">
              {item.options.map((option, optionIndex) => (
                <button key={option} type="button" onClick={() => setAnswers((prev) => ({ ...prev, [index]: optionIndex }))} className={`w-full rounded-xl border px-3 py-2 text-left text-sm font-bold transition ${answers[index] === optionIndex ? "border-[#17A6A4] bg-[#17A6A4] text-white" : "border-[#BFDADC] bg-white text-[#10233E] hover:border-[#17A6A4]"}`}>{option}</button>
              ))}
            </div>
          </div>
        ))}
      </div>
      {complete && <button type="button" onClick={() => setAnswers({})} className="mt-4 inline-flex items-center gap-2 rounded-full border border-[#BFDADC] bg-white px-4 py-2 text-sm font-black text-[#10233E]"><RotateCcw className="h-4 w-4" />{copy.retake}</button>}
    </div>
  );
}